
export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#2C1810] text-[#F5E6D3] py-16 px-6 lg:px-12 border-t-8 border-[#D4A574]">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          <div>
            <h3 className="text-xl font-bold mb-4 font-['Space_Mono'] tracking-tight">ABOUT US</h3>
            <div className="w-12 h-1 bg-[#D4A574] mb-4"></div>
            <p className="text-[#F5E6D3]/80 text-xs leading-relaxed mb-4 font-['DM_Sans']">
              A faith-based organization dedicated to serving communities through ministry, compassion, and spiritual guidance.
            </p>
            <p className="text-[#D4A574] text-xs font-['Crimson_Text'] italic">
              "Let your light shine before others." - Matthew 5:16
            </p>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 font-['Space_Mono'] tracking-tight">QUICK LINKS</h3>
            <div className="w-12 h-1 bg-[#D4A574] mb-4"></div>
            <ul className="space-y-2 text-xs font-['DM_Sans']">
              <li>
                <a href="#home" className="text-[#F5E6D3]/80 hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                  HOME
                </a>
              </li>
              <li>
                <a href="#mission" className="text-[#F5E6D3]/80 hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                  OUR MISSION
                </a>
              </li>
              <li>
                <a href="#subsidiaries" className="text-[#F5E6D3]/80 hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                  MINISTRY OUTREACH
                </a>
              </li>
              <li>
                <a href="#news" className="text-[#F5E6D3]/80 hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                  LATEST NEWS
                </a>
              </li>
              <li>
                <a href="#calendar" className="text-[#F5E6D3]/80 hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                  EVENTS CALENDAR
                </a>
              </li>
              <li>
                <a href="#contact" className="text-[#F5E6D3]/80 hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                  CONTACT US
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 font-['Space_Mono'] tracking-tight">CONTACT INFO</h3>
            <div className="w-12 h-1 bg-[#D4A574] mb-4"></div>
            <ul className="space-y-3 text-xs text-[#F5E6D3]/80 font-['DM_Sans']">
              <li className="flex items-center gap-2">
                <i className="ri-mail-fill text-[#D4A574]"></i>
                <a href="mailto:EandILegacyHoldings@gmail.com" className="hover:text-[#D4A574] transition-colors cursor-pointer">
                  EandILegacyHoldings@gmail.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xl font-bold mb-4 font-['Space_Mono'] tracking-tight">STAY CONNECTED</h3>
            <div className="w-12 h-1 bg-[#D4A574] mb-4"></div>
            <p className="text-[#F5E6D3]/80 text-xs mb-4 font-['DM_Sans']">
              Subscribe to our newsletter
            </p>
            <form className="space-y-3" data-readdy-form id="newsletter-subscription">
              <input
                type="email"
                name="email"
                placeholder="YOUR EMAIL"
                required
                className="w-full px-4 py-2 bg-transparent border-2 border-[#F5E6D3] focus:outline-none focus:border-[#D4A574] text-xs font-['DM_Sans'] placeholder-[#F5E6D3]/50"
              />
              <button
                type="submit"
                className="w-full px-4 py-2 bg-[#D4A574] text-[#2C1810] font-bold font-['Space_Mono'] hover:bg-[#F5E6D3] transition-all cursor-pointer whitespace-nowrap text-xs tracking-wide"
              >
                SUBSCRIBE
              </button>
            </form>
            <div className="flex gap-4 mt-6">
              <a href="#" className="w-10 h-10 border-2 border-[#F5E6D3] flex items-center justify-center hover:bg-[#D4A574] hover:border-[#D4A574] transition-all cursor-pointer">
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-[#F5E6D3] flex items-center justify-center hover:bg-[#D4A574] hover:border-[#D4A574] transition-all cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 border-2 border-[#F5E6D3] flex items-center justify-center hover:bg-[#D4A574] hover:border-[#D4A574] transition-all cursor-pointer">
                <i className="ri-instagram-fill text-lg"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t-2 border-[#D4A574] pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-[#F5E6D3]/60 font-['Space_Mono']">
            <p>© {currentYear} MINISTRY HOLDING COMPANY. ALL RIGHTS RESERVED.</p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide"
            >
              POWERED BY READDY
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
